const ApiPath = {
  Login: 'user/login',
  Logout: 'user/logout',
  Account: 'account',
  AccountCategory: 'account/category',
  Vehicle: 'vehicle',
  User: 'user',
  PosTerminal: 'pos-terminal',
  Transaction: 'transaction',
  FareMatrix: 'fare-matrix',
  GenerateReport: 'report',
  TransactionDashboard: 'transaction/dashboard',
  TransactionDashboard2: 'transaction/v2/dashboard',
  TransactionDashboard3: 'transaction/v3/dashboard',
  // CMMS API
  Customer: 'customer'
};

export default ApiPath;
